import React, { useEffect, useState, } from "react";
import { Button, Tabs, Tab } from "react-bootstrap";
import { createStreamLanguage, getStream, updateStream, updateStreamLanguage, enableStreamQualities } from "../../../../../../api/cp/stream";
import ModalGeneralTab from "./ModalGeneralTab";
import ModalTechnicalTab from "./ModalTechnicalTab";
import ModalStreamsTab from "./ModalStreamsTab";
import { getLiveProfiles } from "../../../../../../api/cp/liveProfile";
import { getRecordProfiles } from "../../../../../../api/cp/recordProfile";
import { useUserContext } from "../../../../../context";

export default ({ event, streamID, updateStreams, onClose = () => { } }) => {

    const { userIsAdmin } = useUserContext();

    const [editingStream, setEditingStream] = useState(null);
    const [isSaving, setSaving] = useState(false);
    const [liveProfiles, setLiveProfiles] = useState([]);
    const [recordProfiles, setRecordProfiles] = useState([]);

    const fetchStream = async (id) => {
        try {
            const stream = await getStream(id);
            setEditingStream(stream);
        } catch (e) {
            console.error(e)
        }
    }

    const getProfiles = () => {
        getLiveProfiles()
            .then(profiles => setLiveProfiles(profiles))
            .catch(e => console.error(e));

        getRecordProfiles()
            .then(profiles => setRecordProfiles(profiles))
            .catch(e => console.error(e));
    }

    useEffect(() => {
        if (streamID) {
            fetchStream(streamID);
            getProfiles();
        } else {
            setEditingStream(null)
        }
    }, [streamID]);

    const handleSave = async () => {
        setSaving(true);

        try {
            enableStreamQualities(editingStream.id, (editingStream?.quality || []).filter(({enabled}) => enabled).map(({id}) => id));
            
            editingStream.language.forEach(async (language) => await (language.id ? updateStreamLanguage(language.id, language) : createStreamLanguage(editingStream.id, language)));

            const stream = await updateStream(editingStream.id, { ...editingStream, descriptionRu: editingStream.description_ru, descriptionEn: editingStream.description_en });
            updateStreams(stream);
            onClose();
        } catch (e) {
            console.error(e)
        } finally {
            setSaving(false)
        }
    }

    if (!editingStream) return null;

    return <>
        <Tabs id="streams-settings-tabs">
            <Tab eventKey={'general'} title="Основные">
                <ModalGeneralTab
                    event={event}
                    editingStream={editingStream}
                    setEditingStream={setEditingStream}
                    updateStreams={updateStreams}
                    setSaving={setSaving}
                    isSaving={isSaving}
                />
            </Tab>
            {userIsAdmin && <Tab eventKey={'technical'} title="Технические">
                <ModalTechnicalTab
                    editingStream={editingStream}
                    setEditingStream={setEditingStream}
                    isSaving={isSaving}
                    liveProfiles={liveProfiles}
                    recordProfiles={recordProfiles}
                />
            </Tab>}
            <Tab eventKey={'streams'} title="Потоки">
                <ModalStreamsTab
                    event={event}
                    stream={editingStream}
                    liveProfiles={liveProfiles}
                    recordProfiles={recordProfiles}
                />
            </Tab>
        </Tabs>

        <Button bsStyle="success" style={{ marginTop: '1rem', width: '100%' }} onClick={handleSave} >Сохранить</Button>
    </>
}
